import * as React from 'react';
import { promosRequestByParamsAction } from '../../actions/promos';
import { IBrowserHistoryState } from '../../types/browserHistory';
import { TThunkDispatch } from '../../types/redux/thunk';

export const useLocationChange = (dispatch: TThunkDispatch) => {
  const handleLocationChange = React.useCallback(
    async (event: PopStateEvent) => {
      const historyState = event.state as IBrowserHistoryState;

      await dispatch(promosRequestByParamsAction(historyState));
    },
    [dispatch],
  );

  React.useEffect(() => {
    window.addEventListener('popstate', handleLocationChange);

    return () => window.removeEventListener('popstate', handleLocationChange);
  }, [handleLocationChange]);
};
